export default __webpack_public_path__ + "static/media/gojelly_startseite_bg.bc91d99e.jpg";